import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	padding: ${(props) => props.padding * 1}rem;
	margin: ${(props) => props.margin * 0.5}rem;
	max-height: 100%;
	overflow: auto;

	&.background {
		background-color: var(--white);
	}
	&.border {
		border: 1px solid var(--border-color);
	}
	&.rounded {
		border-radius: var(--small-border-radius);

		@media ${Breakpoints.mobile} {
			border-radius: 0;
		}
	}
	&.shadowed {
		box-shadow: var(--container-box-shadow);
	}
	&.fullWidth {
		width: 100%;
	}
	&.fullHeight {
		min-height: 100%;
	}
`;
